/* Collapses long spec tables to a preview height with a "Show all models"
   toggle. All rows stay in the DOM at all times (nothing is injected via
   JS), so search engines still see the full spec table — this only
   affects what's visually shown before the visitor expands it.

   Whether a table actually needs collapsing is measured, not assumed:
   every .pml-spec-table-wrap is checked for real overflow past its capped
   height, and only those that actually overflow get the clip/fade/button
   treatment. Short tables render as plain, uncapped tables. */
(function () {
  function labelFor(btn) {
    var custom = btn.getAttribute('data-label');
    if (custom) return custom;
    var count = btn.getAttribute('data-row-count');
    return count ? 'Show all ' + count + ' models' : 'Show all models';
  }

  function initWrap(wrap) {
    if (wrap.classList.contains('is-expanded')) return;

    wrap.classList.add('pml-can-collapse');
    var overflowing = wrap.scrollHeight > wrap.clientHeight + 1;
    var btn = wrap.nextElementSibling && wrap.nextElementSibling.classList.contains('pml-table-expand-btn')
      ? wrap.nextElementSibling
      : null;

    if (!overflowing) {
      wrap.classList.remove('pml-can-collapse');
      if (btn) btn.style.display = 'none';
      return;
    }

    if (btn) {
      btn.style.display = '';
      btn.textContent = labelFor(btn);
    }
  }

  function initAll() {
    document.querySelectorAll('.pml-spec-table-wrap').forEach(initWrap);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pml-table-expand-btn');
    if (!btn) return;
    var wrap = btn.previousElementSibling;
    if (!wrap || !wrap.classList.contains('pml-spec-table-wrap')) return;
    var expanded = wrap.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    btn.textContent = expanded ? 'Show fewer' : labelFor(btn);
  });

  document.addEventListener('DOMContentLoaded', initAll);

  /* Web fonts can swap in after DOMContentLoaded and change row heights
     enough to flip a table from "fits" to "overflows" (or vice versa) —
     re-measure once fonts and the full page (images, iframes) have
     settled, so the button/clip state matches what actually renders. */
  window.addEventListener('load', initAll);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initAll);
  }
})();
